<h2 mat-dialog-title>{{ data.item ? 'Editar Forma de Frete' : 'Nova Forma de Frete' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descrição</mat-label>
          <input matInput formControlName="descricao" placeholder="Ex: PAC, SEDEX..." required>
          @if (form.get('descricao')?.hasError('required')) {
          <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-md-6 col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Código do serviço</mat-label>
          <input matInput formControlName="codigoServico" placeholder="Ex: 03298">
        </mat-form-field>
      </div>
      <div class="col-md-6 col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de entrega</mat-label>
          <mat-select formControlName="idTipoEntrega">
            @for (tipo of data.tiposEntrega; track tipo.idTipoEntrega) {
            <mat-option [value]="tipo.idTipoEntrega">{{ tipo.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12">
        <app-select-pesquisavel [control]="transportadorControl" label="Transportadora" [apiUrl]="urlTransportador"
          idField="id" nameField="descricao" [isOptional]="true">
        </app-select-pesquisavel>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="form.invalid">Salvar</button>
</mat-dialog-actions>